import { DateISO, Pagination } from 'api/interfaces';
import { get, post, put } from 'api/methods';
import {
  AssembleiaTipoPauta,
  TipoVotoPauta,
} from 'helpers/enums/AssembleiaPautaStatus';
import { IAssembleiasAssessorPauta } from 'store/modules/AssembleiasAssessorReducer';

export enum StatusResultado {
  Bloquear,
  Liberar,
}

interface PautaEventoItemRepresentanteChapa {
  associado: string;
  idCargo: number;
  idRepresentanteChapa: number;
  nomeCargo: 'DESCONHECIDO';
}

export interface PautaEventoItem {
  descricao: string;
  flgAbstencao: number;
  idItemPauta: number;
  quantidadeVotos: number;
  representantesChapa: PautaEventoItemRepresentanteChapa[];
}

interface PautaEventoVoto {
  cpfRepresentante: string;
  data: DateISO;
  idConvocado: number;
  idEvento: number;
  idItemPauta: number;
  idPauta: number;
  tipo: number;
}

export interface PautaEvento {
  codigoAgencia: string;
  descricao: string;
  flgRestrita: boolean;
  flgSecreta: boolean;
  estaVotadoPorOutroRepresentante: boolean;
  idPauta: number;
  itens: PautaEventoItem[];
  numeroNucleo: string;
  ordem: number;
  resultadoLiberado: boolean;
  resultadoLiberadoAssociado: boolean;
  resultadoLiberadoPresencial: boolean;
  status: number;
  statusPresencial: string;
  tempoRestante: number;
  tempoVotacao: number;
  tipoPauta: AssembleiaTipoPauta;
  tipoVotoPauta: TipoVotoPauta;
  titulo: string;
  votos: PautaEventoVoto[];
  paginaPresencial: boolean | undefined;
}

export type PautasEventoResponse = Pagination<PautaEvento[]>;

export interface PautasEventoRequest {
  idEvento: number;
  page: number;
}

const pautas = {
  listar: (params: PautasEventoRequest) => {
    return get<PautasEventoResponse>('assembleiasAssessor', 'pauta', {
      params,
    });
  },
  listarPautasByEventoCPF: (idEvento: string, cpf: string) => {
    return get<IAssembleiasAssessorPauta[]>(
      'assembleiasAssessor',
      `pauta/pautas-agencia/${idEvento}/${cpf}`
    );
  },
  statusResultado: (
    idEvento: number,
    idPauta: number,
    status: StatusResultado
  ) => {
    return put('assembleiasAssessor', 'pauta/status-resultado', {
      idEvento,
      idPauta,
      status,
    });
  },
  liberarResultadoAssociado: (
    idEvento: number | string | any,
    idPauta: number
  ) => {
    return post(
      'assembleiasAssessor',
      `pauta/liberar-resultado?idEvento=${idEvento}&oidPauta=${idPauta}`
    );
  },
  filtrarTipoPautas: (
    idEvento: number | string | any,
    tipos: Array<string>
  ) => {
    return get(
      'assembleiasAssessor',
      `pauta/filtrar/pauta?idEvento=${idEvento}&types=${tipos}`
    );
  },
};

export default pautas;
